import React, { useEffect, useState } from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck, Smartphone, Clock } from 'lucide-react';
export function PricingSection() {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <Section background="forest" id="pricing" data-id="element-104">
      <div className="max-w-2xl mx-auto bg-[#FDF8F0] rounded-3xl overflow-hidden shadow-2xl" data-id="element-105">
        {/* Offer Details */}
        <div className="p-6 md:p-10 flex flex-col justify-center" data-id="element-106">
          <h2 className="text-3xl font-bold text-[#1B4332] mb-2" data-id="element-107">
            Botiquín Natural Responsable
          </h2>
          <p className="text-gray-600 mb-4" data-id="element-108">
            Guía completa + Fichas imprimibles + Semáforo
          </p>

          <img src="https://cdn.magicpatterns.com/uploads/8HHGQr1ZVUBmfCy7JAhUWg/imagen_botiquin_natural.png" alt="Botiquín Natural Responsable en dispositivos" className="w-full h-auto object-contain rounded-xl mb-4" data-id="element-109" />

          {/* Scarcity Banner */}
          <div className="text-center mb-4" data-id="element-110">
            <span className="inline-flex items-center gap-1 bg-black text-white rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider animate-pulse" data-id="element-111">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-3 h-3 text-[#EF4444]" data-id="element-112">
                <path fillRule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 6a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 6zm0 9a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" data-id="element-113" />
              </svg>
              OFERTA ÚLTIMOS 25 CUPOS 50% OFF
            </span>
          </div>

          <div className="flex items-end gap-3 mb-4" data-id="element-114">
            <div className="flex flex-col" data-id="element-115">
              <span className="text-xs text-gray-400 uppercase tracking-wider mb-0.5" data-id="element-116">
                Antes
              </span>
              <span className="text-2xl text-gray-400 line-through font-serif" data-id="element-117">
                $1.194
              </span>
            </div>
            <div className="flex flex-col" data-id="element-118">
              <span className="text-xs text-[#C9963A] uppercase tracking-wider font-bold mb-0.5" data-id="element-119">
                Hoy
              </span>
              <span className="text-5xl font-serif font-bold text-[#1B4332] leading-none" data-id="element-120">
                $597
              </span>
            </div>
            <span className="text-sm font-medium text-gray-400 pb-1" data-id="element-121">UYU</span>
          </div>

          {/* Countdown Timer */}
          <div className="bg-[#1B4332] rounded-xl p-4 mb-6 text-center" data-id="element-122">
            <div className="flex items-center justify-center gap-2 mb-2" data-id="element-123">
              <Clock className="w-4 h-4 text-[#C9963A]" data-id="element-124" />
              <span className="text-[#C9963A] font-bold text-sm uppercase tracking-wider" data-id="element-125">
                Oferta solo por hoy
              </span>
            </div>
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-126">
              <div className="bg-white/10 rounded-lg px-4 py-2" data-id="element-127">
                <span className="text-3xl font-bold text-white font-mono" data-id="element-128">
                  {String(minutes).padStart(2, '0')}
                </span>
                <span className="text-xs text-white/60 block" data-id="element-129">Min</span>
              </div>
              <span className="text-2xl font-bold text-[#C9963A]" data-id="element-130">:</span>
              <div className="bg-white/10 rounded-lg px-4 py-2" data-id="element-131">
                <span className="text-3xl font-bold text-white font-mono" data-id="element-132">
                  {String(seconds).padStart(2, '0')}
                </span>
                <span className="text-xs text-white/60 block" data-id="element-133">Seg</span>
              </div>
            </div>
            <p className="text-white/70 text-xs leading-snug max-w-xs mx-auto" data-id="element-134">
              Tu lugar estará reservado durante 15 minutos. En caso de no
              acceder, se cederá el descuento a la siguiente persona.
            </p>
          </div>

          <div className="space-y-3 mb-6" data-id="element-135">
            <div className="flex items-center gap-3 text-gray-700" data-id="element-136">
              <Smartphone className="w-5 h-5 text-[#C9963A]" data-id="element-137" />
              <span data-id="element-138">Funciona en celular, tablet y PC</span>
            </div>
            <div className="flex items-center gap-3 text-gray-700" data-id="element-139">
              <ShieldCheck className="w-5 h-5 text-[#C9963A]" data-id="element-140" />
              <span data-id="element-141">Pago seguro y garantía de satisfacción</span>
            </div>
          </div>

          <Button size="lg" fullWidth className="text-lg font-bold shadow-xl" onClick={() => window.open('https://factorclaro.com/cart/45270142386355:1', '_self')} data-id="element-142">
            Comprar Ahora
          </Button>

          <p className="text-xs text-center text-gray-500 mt-4" data-id="element-143">
            Precio final. Sin suscripciones ni costos ocultos.
          </p>
        </div>
      </div>
    </Section>;
}